export const interventionTypeOptions = [
  { label: "Consultation", value: "consultation" },
  { label: "Medication", value: "medication" },
  { label: "Lab Test", value: "lab_test" },
  { label: "Imaging", value: "imaging" },
  { label: "Surgery", value: "surgery" },
  { label: "Therapy", value: "therapy" },
  { label: "Follow-up", value: "follow_up" },
  { label: "Education", value: "education" },
];
